import {
  GUEST_RECONNECT_RETRY_CAP_MS,
  isDisconnectRetryable,
} from '@playcastdotio/PeerCore';
import type { RetryPolicy } from './ClientPeerManager';

/**
 * Production guests skip in-session reclaim (maxRetries: 0) and refresh the peer
 * stack as soon as PeerCore emits a retryable disconnect. Delay helpers remain for
 * tests and any caller that still opts into a reclaim ladder.
 *
 * When reclaim is enabled, the first attempt is immediate: ICE grace already proved
 * the transport dead.
 */
export const quickstartRetryPolicy: RetryPolicy = {
  maxRetries: 0,
  shouldRetry: (reason: string, _attempt: number) => isDisconnectRetryable(reason),
  retryDelayMs: (attempt: number) =>
    attempt <= 1 ? 0 : Math.min(250 * Math.pow(2, attempt - 2), GUEST_RECONNECT_RETRY_CAP_MS),
};
